import { Fragment, useEffect } from 'react'
import { Button, Card, Col, Form, Row } from 'react-bootstrap'
import { useState } from 'react'
import Swal from 'sweetalert2'
import axios from 'axios'
import config from '../../config'
import Cookies from 'js-cookie'
import { fetchCouponType } from '../../helpers/couponApi'

const RecheckShipping = () => {
  const [barcode, setBarcode] = useState('')
  const [lotteryOrder, setLotteryOrder] = useState([])
  const coupons = JSON.parse(localStorage.getItem('coupons'))

  useEffect(() => {
    if (!coupons) {
      fetchCouponType()
    }
  }, [coupons])

  const fetchLotteryOrderByBarcode = async () => {
    try {
      const response = await axios.get(`${config.apiAdminGateway}/api/v1/admin/orders/has-lottery/${barcode}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get('accessToken')}`,
        },
      })
      const data = response.data.data
      if (data) {
        setLotteryOrder([...lotteryOrder, data])
      }

      alertLotteryOrder(data)
    } catch (error) {
      Swal.fire({
        title: 'ลอตเตอรี่นี้ไม่มีอยู่ในระบบ',
        text: 'กรุณายิง QR code ใหม่',
        showCloseButton: true,
      })
    }
  }

  const alertLotteryOrder = (order) => {
    if (order.couponId === coupons.DELIVER) {
      return Swal.fire({
        title: 'มีการจัดส่ง Delivery',
        text: `ออเดอร์ ${order.refNo}`,
        html: `<b> User ${order.userId}</b> : <b>งวดที่ ${order.roundDate}</b>`,
        showCloseButton: true,
      })
    } else if (order.couponId === coupons.SLOT) {
      return Swal.fire({
        title: 'ไม่มีการจัดส่ง',
        text: `ออเดอร์ ${order.refNo}`,
        html: `<b> User ${order.userId}</b> : <b>งวดที่ ${order.roundDate}</b>`,
        showCloseButton: true,
      })
    } else {
      return Swal.fire({
        title: 'ลอตเตอรี่ใบนี้ไม่มีข้อมูลการจัดเก็บและการจัดส่ง',
        text: `ออเดอร์ ${order.refNo} `,
        html: `<b> User ${order.userId}</b> : <b>งวดที่ ${order.roundDate}</b>`,
        showCloseButton: true,
      })
    }
  }
  const fetchTypeOrder = async () => {
    if (lotteryOrder.length) {
      const order = lotteryOrder.find((order) => order.items.find((item) => item === barcode))

      if (order) {
        alertLotteryOrder(order)
      } else {
        fetchLotteryOrderByBarcode()
      }
    } else {
      fetchLotteryOrderByBarcode()
    }
    setBarcode('')
  }

  return (
    <Fragment>
      <Card style={{ width: '50%' }}>
        <Card.Header>
          <Card.Title>ScanShipping</Card.Title>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col>
              <Form.Group
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: ' baseline',
                }}
              >
                <Form.Label>
                  <Form.Control
                    style={{ width: '200px', color: '#000' }}
                    type="text"
                    value={barcode}
                    maxLength="15"
                    onChange={(e) => {
                      let val = e.target.value
                      val.match(/^[0-9-]*$/) && setBarcode(val)
                    }}
                  />
                </Form.Label>
                <Button variant="primary light" onClick={fetchTypeOrder}>
                  ค้นหา
                </Button>
              </Form.Group>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default RecheckShipping
